import SqlEditor from '../Sql/SqlEditor/SqlEditor';

interface IQueryCodeProps {
	query: string;
	minHeight?: number;
	className?: string;
	lineNumbers?: boolean;
}

export function QueryCode({
	query,
	minHeight = 274,
	className,
	lineNumbers = false,
}: IQueryCodeProps) {
	return (
		<SqlEditor
			lineNumbers={lineNumbers}
			defaultValue={query}
			minHeight={minHeight}
			readOnly
			className={className}
		/>
	);
}
